"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
var hooks_1 = require("preact/hooks");
var useMediaQuery = function (query) {
    var mediaMatch = window.matchMedia(query);
    var _a = (0, hooks_1.useState)(mediaMatch.matches), matches = _a[0], setMatches = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handler = function (e) { return setMatches(e.matches); };
        mediaMatch.addEventListener("change", handler);
        return function () { return mediaMatch.removeEventListener("change", handler); };
    }, [mediaMatch]);
    return matches;
};
exports.useMediaQuery = useMediaQuery;
